import React from "react"

const Logo = ({
  name = "",
  style = {},
  fill = "",
  viewBox = "",
  width = "100%",
  className = "",
  height = "100%",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 145.13 98.71"
  >
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M140.65,14.43a29.11,29.11,0,0,0-12.8-10.67A47.12,47.12,0,0,0,108.26,0H0V92.82a5.9,5.9,0,0,0,5.9,5.89H94.62a5.89,5.89,0,0,0,5.89-5.89V61.5h7.75a48,48,0,0,0,19.59-3.7,28.61,28.61,0,0,0,12.8-10.68,29.45,29.45,0,0,0,4.48-16.31A29.43,29.43,0,0,0,140.65,14.43ZM70.32,78.3l-.09-34.73-17,28.61h-6L30.2,44.31v34H17.63V20.41H28.71l21.67,36,21.34-36h11l.17,57.89Zm50.31-36.63q-4.6,3.81-13.46,3.82h-6.66V16h6.66q8.85,0,13.46,3.82t4.61,11Q125.24,37.85,120.63,41.67Z"
        />
      </g>
    </g>
  </svg>
)

const TextLogo = ({
  name = "",
  style = {},
  fill = "#000",
  viewBox = "",
  width = "100%",
  className = "",
  height = "100%",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 396.99 64.53"
  >
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M131.86,54.05h2.78V62a10.89,10.89,0,0,1-3.5,1.92,13.19,13.19,0,0,1-4.17.66,11.36,11.36,0,0,1-5.54-1.35,10,10,0,0,1-3.86-3.7,10.76,10.76,0,0,1,0-10.65,9.89,9.89,0,0,1,3.88-3.71,12.45,12.45,0,0,1,10-.53,9,9,0,0,1,3.38,2.33l-1.8,1.8a8.14,8.14,0,0,0-5.88-2.35,8.56,8.56,0,0,0-4.16,1,7.4,7.4,0,0,0-2.88,2.78,8.21,8.21,0,0,0,0,8A7.57,7.57,0,0,0,123,60.94a9.15,9.15,0,0,0,8.88-.29Z"
        />
        <path
          className="cls-1"
          d="M167.75,59.23H157l-2.23,5.07h-3L160.94,44h2.87L173,64.3h-3Zm-1-2.32L162.36,47,158,56.91Z"
        />
        <path
          className="cls-1"
          d="M209.49,64.3l0-14.77-7.33,12.31H200.8l-7.33-12.22V64.3h-2.78V44h2.37l8.46,14.25L209.86,44h2.38l0,20.28Z"
        />
        <path
          className="cls-1"
          d="M247.72,61.78V64.3H233V44h14.31v2.52H235.9v6.23h10.17v2.46H235.9v6.55Z"
        />
        <path
          className="cls-1"
          d="M268.56,63.82A9,9,0,0,1,265.22,62l1.07-2.26a8.84,8.84,0,0,0,3,1.7,11,11,0,0,0,3.72.65,6.68,6.68,0,0,0,3.76-.86A2.62,2.62,0,0,0,278,58.94a2.24,2.24,0,0,0-.68-1.69,4.56,4.56,0,0,0-1.68-1c-.67-.23-1.61-.49-2.83-.78a29.31,29.31,0,0,1-3.69-1.11,6,6,0,0,1-2.4-1.69,4.5,4.5,0,0,1-1-3.08,5.21,5.21,0,0,1,.85-2.93,5.83,5.83,0,0,1,2.59-2.08,10.39,10.39,0,0,1,4.32-.79,13.53,13.53,0,0,1,3.53.47,9.53,9.53,0,0,1,3,1.33l-1,2.32a10.58,10.58,0,0,0-2.72-1.23,10.18,10.18,0,0,0-2.84-.42,6.31,6.31,0,0,0-3.69.89,2.75,2.75,0,0,0-1.23,2.32,2.22,2.22,0,0,0,.69,1.69,4.74,4.74,0,0,0,1.72,1c.69.24,1.62.49,2.8.77a27.24,27.24,0,0,1,3.68,1.1,6.06,6.06,0,0,1,2.39,1.68,4.44,4.44,0,0,1,1,3,5.18,5.18,0,0,1-.87,2.91,5.8,5.8,0,0,1-2.64,2.08,10.74,10.74,0,0,1-4.34.77A14,14,0,0,1,268.56,63.82Z"
        />
        <path
          className="cls-1"
          d="M26,29l0-17.1L17.52,26h-3L6.19,12.26V29H0V.49H5.46L16.13,18.21,26.64.49h5.42L32.14,29Z"
        />
        <path
          className="cls-1"
          d="M44.71,27.58a14.19,14.19,0,0,1-5.58-5.28,14.35,14.35,0,0,1-2-7.55,14.36,14.36,0,0,1,2-7.56,14.19,14.19,0,0,1,5.58-5.28,17.69,17.69,0,0,1,16,0,14.47,14.47,0,0,1,5.58,5.28,14.28,14.28,0,0,1,2,7.56,14.27,14.27,0,0,1-2,7.55,14.47,14.47,0,0,1-5.58,5.28,16.5,16.5,0,0,1-8,1.91A16.57,16.57,0,0,1,44.71,27.58Zm12.57-4.87a8.28,8.28,0,0,0,3.19-3.24,9.44,9.44,0,0,0,1.17-4.72A9.48,9.48,0,0,0,60.47,10a8.42,8.42,0,0,0-3.19-3.24,9.56,9.56,0,0,0-9.13,0A8.44,8.44,0,0,0,45,10a9.58,9.58,0,0,0-1.16,4.73A9.54,9.54,0,0,0,45,19.47a8.31,8.31,0,0,0,3.2,3.24,9.56,9.56,0,0,0,9.13,0Z"
        />
        <path
          className="cls-1"
          d="M91.46,29,86,21.06H79.89V29h-6.6V.49H85.63a15.86,15.86,0,0,1,6.58,1.26,9.8,9.8,0,0,1,4.3,3.59,9.89,9.89,0,0,1,1.5,5.5,9.78,9.78,0,0,1-1.52,5.48,9.77,9.77,0,0,1-4.34,3.52L98.54,29ZM89.78,7.15a6.88,6.88,0,0,0-4.52-1.28H79.89v9.94h5.37a6.83,6.83,0,0,0,4.52-1.31,4.5,4.5,0,0,0,1.55-3.66A4.48,4.48,0,0,0,89.78,7.15Z"
        />
        <path
          className="cls-1"
          d="M129.38.49V29H124L109.75,11.69V29h-6.52V.49h5.46L122.86,17.8V.49Z"
        />
        <path className="cls-1" d="M136.14.49h6.6V29h-6.6Z" />
        <path
          className="cls-1"
          d="M175.66.49V29h-5.42L156,11.69V29h-6.51V.49H155L169.14,17.8V.49Z"
        />
        <path
          className="cls-1"
          d="M201.69,14.3h6V25.87a17.3,17.3,0,0,1-5.38,2.69,21,21,0,0,1-6.15.93,16.68,16.68,0,0,1-8-1.89,14,14,0,0,1-5.57-5.26,14.5,14.5,0,0,1-2-7.59,14.51,14.51,0,0,1,2-7.6,14.16,14.16,0,0,1,5.61-5.26A17,17,0,0,1,196.31,0a17.64,17.64,0,0,1,6.8,1.26,13.64,13.64,0,0,1,5.14,3.67L204,8.84a9.82,9.82,0,0,0-7.37-3.22,10.07,10.07,0,0,0-4.85,1.14,8.18,8.18,0,0,0-3.3,3.22,9.45,9.45,0,0,0-1.18,4.77,9.34,9.34,0,0,0,1.18,4.72,8.31,8.31,0,0,0,3.28,3.24,9.65,9.65,0,0,0,4.79,1.16,10.62,10.62,0,0,0,5.13-1.22Z"
        />
        <path
          className="cls-1"
          d="M242.18,1.76a9.71,9.71,0,0,1,4.31,3.59A9.93,9.93,0,0,1,248,10.87a9.93,9.93,0,0,1-1.51,5.5,9.54,9.54,0,0,1-4.31,3.6,16.16,16.16,0,0,1-6.6,1.24h-5.76V29.1H223.2V.49h12.38A15.83,15.83,0,0,1,242.18,1.76Zm-2.43,12.77a4.48,4.48,0,0,0,1.55-3.66,4.53,4.53,0,0,0-1.55-3.7,7,7,0,0,0-4.54-1.28h-5.39v9.93h5.39A7,7,0,0,0,239.75,14.53Z"
        />
        <path
          className="cls-1"
          d="M274.86,23.79V29.1H252.71V.49h21.62V5.8h-15V12h13.28v5.15H259.29v6.62Z"
        />
        <path
          className="cls-1"
          d="M298.36,29.1l-5.52-8h-6.09v8h-6.62V.49h12.39a15.83,15.83,0,0,1,6.6,1.27,9.77,9.77,0,0,1,4.31,3.59,9.93,9.93,0,0,1,1.51,5.52,9.72,9.72,0,0,1-1.53,5.5,9.64,9.64,0,0,1-4.35,3.53l6.41,9.2ZM296.68,7.17a7,7,0,0,0-4.53-1.28h-5.4v10h5.4a6.86,6.86,0,0,0,4.53-1.31,4.54,4.54,0,0,0,1.56-3.68A4.54,4.54,0,0,0,296.68,7.17Z"
        />
        <path
          className="cls-1"
          d="M313,28.67a15.27,15.27,0,0,1-5.09-2.39l2.25-5a15,15,0,0,0,4.37,2.16,16.29,16.29,0,0,0,5.07.82,8.09,8.09,0,0,0,4.17-.84,2.52,2.52,0,0,0,1.34-2.23,2.12,2.12,0,0,0-.79-1.69,6.11,6.11,0,0,0-2-1.09c-.83-.27-2-.57-3.37-.9A44.65,44.65,0,0,1,313.57,16,8.8,8.8,0,0,1,310,13.49a6.77,6.77,0,0,1-1.49-4.58,8,8,0,0,1,1.35-4.52,9.11,9.11,0,0,1,4.06-3.2A16.65,16.65,0,0,1,320.56,0a22.26,22.26,0,0,1,5.35.65,16.11,16.11,0,0,1,4.58,1.88l-2,5a16,16,0,0,0-7.93-2.25,7.41,7.41,0,0,0-4.11.9,2.74,2.74,0,0,0-1.33,2.37,2.33,2.33,0,0,0,1.53,2.19,23.55,23.55,0,0,0,4.68,1.41,49,49,0,0,1,5.36,1.55,8.82,8.82,0,0,1,3.57,2.46,6.53,6.53,0,0,1,1.5,4.53,7.84,7.84,0,0,1-1.37,4.48,9.21,9.21,0,0,1-4.11,3.21,16.78,16.78,0,0,1-6.66,1.18A23.11,23.11,0,0,1,313,28.67Z"
        />
        <path
          className="cls-1"
          d="M342.08,27.67a14.23,14.23,0,0,1-5.61-5.29,14.54,14.54,0,0,1-2-7.58,14.56,14.56,0,0,1,2-7.59,14.3,14.3,0,0,1,5.61-5.29,17.71,17.71,0,0,1,16,0,14.3,14.3,0,0,1,7.64,12.88,14.29,14.29,0,0,1-7.64,12.87,17.71,17.71,0,0,1-16,0Zm12.61-4.88a8.33,8.33,0,0,0,3.2-3.25,9.52,9.52,0,0,0,1.17-4.74,9.49,9.49,0,0,0-1.17-4.74,8.27,8.27,0,0,0-3.2-3.25,9.55,9.55,0,0,0-9.16,0,8.36,8.36,0,0,0-3.21,3.25,9.49,9.49,0,0,0-1.17,4.74,9.52,9.52,0,0,0,1.17,4.74,8.43,8.43,0,0,0,3.21,3.25,9.62,9.62,0,0,0,9.16,0Z"
        />
        <path
          className="cls-1"
          d="M397,.49V29.1h-5.44L377.29,11.73V29.1h-6.54V.49h5.47l14.23,17.37V.49Z"
        />
      </g>
    </g>
  </svg>
)

const SteamLogo = ({
  name = "",
  style = {},
  fill = "",
  viewBox = "",
  width = "100%",
  className = "",
  height = "100%",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    style={style}
    fill={fill}
    height={height}
    className={className}
    viewBox="0 0 293.46 88.47"
  >
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M44.08,0A44.23,44.23,0,0,0,0,40.69l23.71,9.8a12.49,12.49,0,0,1,7.05-2.18l.69,0L42,33.05v-.22A16.68,16.68,0,1,1,58.68,49.52H58.3l-15,10.73c0,.2,0,.4,0,.6a12.52,12.52,0,0,1-24.8,2.46l-17-7A44.24,44.24,0,1,0,44.08,0Z"
        />
        <path
          className="cls-1"
          d="M27.72,67.12l-5.43-2.24A9.4,9.4,0,1,0,27.43,52L33,54.35a6.92,6.92,0,1,1-5.32,12.77Z"
        />
        <path
          className="cls-1"
          d="M69.8,32.83A11.12,11.12,0,1,0,58.68,44,11.13,11.13,0,0,0,69.8,32.83Zm-19.45,0a8.35,8.35,0,1,1,8.35,8.35A8.35,8.35,0,0,1,50.35,32.82Z"
        />
        <path
          className="cls-1"
          d="M135.56,30.27l-3,5.21a14.8,14.8,0,0,0-8.08-2.56c-3.08,0-5,1.28-5,3.57,0,2.78,3.39,3.43,8.43,5.24,5.42,1.91,8.54,4.17,8.54,9.13,0,6.79-5.34,10.61-13,10.61a23.63,23.63,0,0,1-11.73-3.08l2.16-5.77a20.5,20.5,0,0,0,9.2,2.37c4,0,6-1.5,6-3.71,0-2.52-2.94-3.29-7.68-4.85-5.4-1.81-9.15-4.18-9.15-9.67,0-6.2,5-9.76,12.11-9.76A19,19,0,0,1,135.56,30.27Z"
        />
        <path
          className="cls-1"
          d="M158.73,33.56V60.9h-7V33.56H141.63v-6h27.2v6Z"
        />
        <path
          className="cls-1"
          d="M183.55,33.54v7.51H196.9v6H183.55v7.82H199v6H176.57V27.57H199v6Z"
        />
        <path
          className="cls-1"
          d="M214.62,54.43l-2.21,6.47H205.1l12.49-33.33h7L237.47,60.9H229.9l-2.25-6.47Zm6.44-18.91-4.55,13.35h9.2Z"
        />
        <path
          className="cls-1"
          d="M273.28,40.45l-9.12,19.48h-3.94l-9-19.3V60.9h-6.68V27.57h6.67l11.2,24.06,10.8-24.06H280V60.9h-6.69Z"
        />
        <path
          className="cls-1"
          d="M293.46,31.78a4.62,4.62,0,1,1-4.61-4.64A4.5,4.5,0,0,1,293.46,31.78Zm-8.46,0a3.84,3.84,0,1,0,7.68,0,3.84,3.84,0,1,0-7.68,0Zm3.91-2.37c1.2,0,1.6.63,1.6,1.31a1.35,1.35,0,0,1-.82,1.26l1.07,2h-.88l-.9-1.78h-.93V34h-.73V29.41Zm-.86,2.13h.82a.76.76,0,0,0,.84-.75c0-.42-.23-.69-.84-.69h-.82Z"
        />
      </g>
    </g>
  </svg>
)

const ItchioLogo = ({
  name = "",
  style = {},
  fill = "",
  viewBox = "",
  width = "100%",
  className = "",
  height = "100%",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    style={style}
    fill={fill}
    height={height}
    className={className}
    viewBox="0 0 774.7776 198.92646"
  >
    <g>
      <path d="M253.95 174.12V70.95h34.81v103.17h-34.81zm17.614-111.56q-8.808 0-13.63-4.404-4.614-4.403-4.614-11.743 0-6.92 4.613-11.743 4.823-4.823 13.63-4.823 8.808 0 13.422 4.823 4.823 4.823 4.823 11.743 0 7.34-4.823 11.743-4.613 4.404-13.42 4.404zM340.7 176.22q-15.1 0-22.86-7.97-7.548-8.177-7.548-22.647v-48.86h-13.84V70.948h13.84V45.784h34.81V70.95h22.65v25.79H345.1v43.828q0 4.824 1.888 6.92 2.097 1.888 6.29 1.888 5.663 0 12.373-5.033l7.97 22.858q-6.08 4.2-13.84 6.71-7.76 2.31-19.08 2.31zm85.62 0q-23.907 0-37.747-13.63-13.63-13.632-13.63-39.635 0-18.873 7.758-31.665 7.97-13.21 19.93-17.825 12.58-4.823 23.28-4.823 13.42 0 22.44 5.452 9.02 5.243 13.21 11.534 4.41 6.29 6.29 9.856l-24.11 15.518q-3.35-6.92-7.34-10.905-3.98-3.984-9.64-3.984-7.97 0-12.58 6.29-4.61 6.292-4.61 19.084 0 13.84 5.45 20.34 5.45 6.502 15.52 6.502 7.97 0 13.21-2.94 5.45-2.94 10.277-7.55l11.115 26q-5.034 4.19-14.89 8.39-9.856 3.98-23.906 3.98zm50.65-2.1V34.04h35.02v42.57q4.403-3.146 10.694-5.452 6.29-2.517 15.1-2.517 18.453 0 27.47 10.49 9.227 10.49 9.227 29.57v65.43h-35.02v-61.24q0-8.8-3.35-12.79-3.35-4.19-8.81-4.19-4.61 0-8.6 2.1-3.98 2.1-6.71 4.41v71.72h-35.02zm124.4 2.1q-8.39 0-13.212-4.823-4.823-4.823-4.823-12.372 0-7.55 4.823-12.582 4.823-5.033 13.21-5.033 7.97 0 12.793 5.033 4.83 5.033 4.83 12.582 0 7.55-4.82 12.372-4.61 4.823-12.79 4.823zm25.75-2.1V70.95h34.81v103.17h-34.81zm17.61-111.54q-8.81 0-13.632-4.404-4.613-4.404-4.613-11.743 0-6.92 4.613-11.743 4.823-4.823 13.63-4.823 8.808 0 13.422 4.823 4.823 4.823 4.823 11.743 0 7.34-4.823 11.743-4.613 4.404-13.42 4.404zm78.67 113.64q-12.164 0-21.6-3.984-9.437-4.194-16.147-11.324-6.5-7.34-10.066-17.196-3.355-10.066-3.355-21.81 0-17.404 7.55-30.406 7.758-12.792 19.292-17.825 11.743-5.033 24.325-5.033 18.03 0 29.77 8.388 11.95 8.388 16.78 20.97 4.82 12.582 4.82 23.906 0 11.743-3.57 21.81-3.35 9.855-10.07 17.195-6.5 7.13-16.15 11.33-9.435 3.99-21.6 3.99zm0-26.842q8.807 0 12.79-7.34 3.985-7.55 3.985-20.13 0-11.954-4.194-19.084-4.19-7.13-12.58-7.13-8.18 0-12.37 7.13-4.19 7.13-4.19 19.083 0 12.582 3.99 20.13 4.2 7.34 12.58 7.34z" />
      <path d="M28.832 1.228C19.188 6.954.186 28.785.004 34.51v9.478c0 12.014 11.23 22.572 21.424 22.572 12.24 0 22.44-10.146 22.442-22.187 0 12.04 9.85 22.187 22.093 22.187 12.242 0 21.776-10.146 21.776-22.187 0 12.04 10.47 22.187 22.71 22.187h.22c12.24 0 22.72-10.146 22.72-22.187 0 12.04 9.53 22.187 21.77 22.187s22.09-10.146 22.09-22.187c0 12.04 10.2 22.187 22.44 22.187 10.19 0 21.42-10.557 21.42-22.572V34.51c-.19-5.725-19.19-27.556-28.83-33.282-29.97-1.053-50.76-1.234-81.73-1.23C79.59 0 37.36.483 28.83 1.228zm58.753 59.674c-1.166 2.046-2.627 3.903-4.308 5.546-4.62 4.52-10.956 7.32-17.94 7.32-6.985 0-13.356-2.8-17.976-7.322-1.67-1.64-2.94-3.394-4.11-5.436v.004c-1.16 2.046-2.79 3.798-4.46 5.44-4.62 4.52-10.99 7.317-17.97 7.317-.84 0-1.71-.23-2.42-.47-.982 10.25-1.4 20.04-1.545 27.19v.04c-.02 3.63-.035 6.61-.054 10.75.19 21.51-2.13 69.7 9.48 81.54 17.99 4.2 51.094 6.11 84.31 6.12h.003c33.214-.01 66.32-1.92 84.31-6.11 11.61-11.843 9.29-60.033 9.48-81.536-.017-4.14-.034-7.122-.053-10.75v-.04c-.15-7.142-.565-16.935-1.55-27.183-.71.24-1.587.473-2.43.473-6.98 0-13.354-2.797-17.975-7.316-1.675-1.644-3.3-3.396-4.463-5.44l-.005-.006c-1.166 2.04-2.437 3.797-4.112 5.436-4.62 4.522-10.99 7.322-17.973 7.322s-13.32-2.8-17.94-7.32c-1.68-1.644-3.14-3.5-4.31-5.547-1.163 2.04-2.59 3.907-4.266 5.546-4.62 4.52-10.99 7.32-17.98 7.32-.244 0-.49-.01-.73-.02h-.008c-.243.01-.486.02-.73.02-6.986 0-13.357-2.8-17.978-7.32-1.678-1.64-3.106-3.503-4.27-5.544zM69.123 84.775l-.002.008h.02c7.31.016 13.81 0 21.85 8.783 6.34-.663 12.95-.996 19.58-.985h.01c6.63-.01 13.24.33 19.58.99 8.05-8.78 14.54-8.76 21.85-8.78h.02v-.01c3.458 0 17.27 0 26.9 27.04l10.347 37.1c7.665 27.6-2.453 28.28-15.073 28.3-18.72-.69-29.08-14.29-29.08-27.88-10.36 1.7-22.45 2.55-34.535 2.55h-.005c-12.086 0-24.172-.85-34.53-2.55 0 13.59-10.36 27.18-29.078 27.88-12.62-.02-22.74-.7-15.073-28.29l10.34-37.1c9.63-27.04 23.45-27.04 26.9-27.04zm41.44 21.25v.007c-.017.017-19.702 18.096-23.24 24.526l12.89-.516v11.24c0 .527 5.174.313 10.35.074h.007c5.177.24 10.35.453 10.35-.073v-11.24l12.89.514c-3.538-6.43-23.24-24.525-23.24-24.525v-.006l-.002.002z" />
    </g>
  </svg>
)

export { Logo, TextLogo, SteamLogo, ItchioLogo }
